import React, { Component } from "react";
import "./Parties.scss";

export default class Parties extends Component {
    constructor() {
        super();
        this.state = {
        }
    }
    handleClick = (el) => {
        // let el = document.querySelector('[data-chair="' + chairNum +'"]');
        // if(el){
        //     el.click();
        // }
        el.click();
    }

    render() {
        return(
            <section>
                <div class="parties">
                    {this.props.partiesData.map(party => (
                        <div className="party" onClick= {(e) => this.handleClick(document.querySelector('[data-chair="' + party.startChair +'"]'))}>
                            <div className={`square ${party.englishName}`}> </div>                       
                            <span>{party.name}</span>
                        </div>
                        
                    ))}
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Parties/Parties.jsx